import { Property } from '@/types';
import { Progress } from './progress';
import { getLandSizeInFt } from './utils';

interface LandComparisionLineItemProps {
  value: number | string;
  comparisionResult: number;
  masterProperty?: Property;
  property: Property;
}

export const LandComparisionLineItem: React.FC<LandComparisionLineItemProps> = (
  props
) => {
  let diff = <></>;

  if (
    props.masterProperty &&
    props.masterProperty.propertyNumber !== props.property.propertyNumber
  ) {
    const landSize = getLandSizeInFt(props.property);
    const masterLandSize = getLandSizeInFt(props.masterProperty);

    const diffSize = Math.round(Number(landSize) - Number(masterLandSize));

    diff = (
      <>
        {' '}
        <span
          className={
            diffSize > 0 && diffSize > 0 ? 'text-green-500' : 'text-red-500'
          }
        >
          ({diffSize} sqft)
        </span>
      </>
    );
  }

  return (
    <div className="relative">
      <Progress value={props.comparisionResult} />
      <div className="px-2 py-2 text-center">&nbsp;</div>
      <div className="px-2 py-2 text-center absolute inset-0 p-1">
        {props.value}&nbsp; {diff}
      </div>
    </div>
  );
};
